import React, { useEffect } from 'react'
import { viewPdfReport } from '../../../service/StudyReportService';
import { useSearchParams } from 'react-router-dom';

const QRCodeScanReport = () => {

    const [searchParams] = useSearchParams();

    useEffect(()=>{
        let studyId = window.location.pathname.split("/").slice(-2)[0];
        let fileTypeSelected = searchParams.get("fileTypeSelected");
        let sourceFirmId =  window.location.pathname.substring(
          window.location.pathname.lastIndexOf("/") + 1
        );
        let payload = {
          studyId : studyId,
          sourceFirmId: sourceFirmId,
          fileTypeSelected: fileTypeSelected
        };
        console.log(payload);
        viewPdfReport(payload);
    },[])

  return (<></>)
}

export default QRCodeScanReport